import React from 'react';
import { useSelector } from 'react-redux';

const AnalyzeHeader = (props) => {

    const { watermark_info, footprint_info, end_watermark, end_footprint} = useSelector(state=>state.analyze_info)



    const onFootprintClick = () => {
        props.setActiveData(footprint_info.fp_track);
        props.setResultLink(footprint_info.result_link);
        if(footprint_info.fp_track && footprint_info.fp_track.genre_title){
            props.setAnalyzeGenre(footprint_info.fp_track.genre_title)
        }
        if(footprint_info.fp_track && footprint_info.fp_track.fp && footprint_info.fp_track.fp.mood){
            props.setAnalyzeMood(footprint_info.fp_track.fp.mood)
        }
        props.setActiveHeader(2)
    }

    const onWatermarkClick = () => {
        props.setActiveData(watermark_info.wm_track);
        props.setResultLink(watermark_info.result_link);
        props.setActiveHeader(1)
        if(watermark_info.wm_track.genre_title){
            props.setAnalyzeGenre(watermark_info.wm_track.genre_title)
        }
    }

    return (
            <div className = "w-100 px-0 px-md-3 d-flex pb-0 pb-md-4 pb-lg-3 flex-column flex-lg-row justify-content-between align-items-center align-items-md-start">
                <div className = "col-12 col-lg-3 col-md-6 text-center text-md-start text-info fs-4 my-1">
                    ANALYSIS RESULTS
                </div>
                <div className = "col-12 col-lg-3 pb-3 pb-md-0 col-md-8 d-flex flex-wrap text-center text-md-start justify-content-center justify-content-md-start"
                    // style={{gap:"0.8rem"}}
                >
                    { end_watermark && watermark_info.wm_track ?
                        <div className='col-5 col-md-6 pe-3'>
                            <div role="button" className = {
                                props.activeHeader === 1 ?
                                    "bg-info text-primary text-center border border-info rounded-pill w-100 watermark-footprint-pill" :
                                    "text-info text-center border border-info rounded-pill w-100 watermark-footprint-pill"
                                }
                            // style={{width:"8.5rem"}}
                            onClick={()=>{onWatermarkClick()}}
                            >WATERMARK</div>
                        </div> : ""
                    }
                    {
                        end_footprint && footprint_info.fp_track ?
                        <div className='col-5 col-md-6'>
                            <div role="button" className = { props.activeHeader === 2 ?
                                "bg-info text-primary text-center border border-info rounded-pill watermark-footprint-pill" :
                                        "text-info text-center border border-info rounded-pill watermark-footprint-pill"
                                    }
                                // style={{width:"8.5rem"}}
                            onClick={()=>{onFootprintClick()}}>FOOTPRINT</div>
                        </div>
                         : ""
                    }
                </div>
            </div>
    );
}

export default AnalyzeHeader;